(function () {
    "use strict";

    angular
        .module("atheer.job")
        .controller("JobPickerController", JobPickerController);

    /* @ngInject */
    function JobPickerController(
        $scope,
        $state,
        $mdDialog,
        Principal,
        Job,
        Feature,
        ParseLinks,
        AlertService,
        sessionId,
        sessionNo
    ) {
        var vm = this;

        vm.sessionId = sessionId;
        vm.sessionNo = sessionNo;
        vm.jobs = [];
        vm.searchJobs = null;
        vm.selectedJob = [];
        vm.isLoading = false;
        vm.isSearchLoading = false;

        vm.isJobLinkageEnabled = Feature.isActive(
            "feature_airsession_enable_air_session_link_with_job"
        );

        /**
         * Creates the payload for the job search.
         * @param {string} jobNumber - The job number to search for.
         * @returns {Object} The payload for the job search.
         */
        vm.createPayload = function (jobNumber) {
            return {
                query: !jobNumber
                    ? "assigneeList.users.id=in=(" + Principal.getUserId() + ")"
                    : "jobNumber==" + jobNumber,
                size: 5,
                sort: "last_modified_on,desc",
                page: 0,
            };
        };

        vm.loadAll = function () {
            vm.isLoading = true;
            getJobData(vm.createPayload());
        };

        /**
         * Gets the job data from the API.
         * @param {Object} query - The query to get the job data.
         */
        function getJobData(query) {
            Job.query(query, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.totalJobs = vm.totalItems;
                vm.jobs = data;
                vm.isSearchLoading = false;
                vm.isLoading = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.isSearchLoading = false;
                vm.isLoading = false;
            }
        }

        /**
         * Handles the job search.
         * @param {string} jobNumber - The job number to search for.
         */
        vm.handleJobSearch = function (jobNumber) {
            vm.isSearchLoading = true;
            getJobData(vm.createPayload(jobNumber));
        };

        vm.removeFilter = function () {
            vm.searchJobs = null;
            vm.isSearchLoading = true;
            getJobData(vm.createPayload());
        };

        vm.close = function () {
            $mdDialog.cancel();
        };

        /**
         * Closes the job picker dialog and returns the selected job.
         */
        vm.linkJob = function () {
            if (vm.selectedJob && vm.selectedJob.length) {
                // call parent compoent to handle the job linkage
                $mdDialog.hide(vm.selectedJob[0]);
            }
        };

        vm.loadAll();
    }
})();
